package com.arena_web.ui.components.widgets

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.arena_web.ui.components.icons.Icon
import com.arena_web.ui.localization.LocalAppStrings
import com.arena_web.ui.theme.*
import com.arena_web.ui.utils.*
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText

/**
 * "⋮" kebab shown next to the avatar+name header of the user's OWN content
 * (post card, story viewer). Opens a one-item dropdown with Delete — the
 * two-step click is the guard against accidental deletion. Styling mirrors
 * the club-post kebab in Settings' ClubPostCard.
 */
@Composable
fun KebabDeleteMenu(onDelete: () -> Unit) {
    val t = LocalAppStrings.current
    var showMenu by remember { mutableStateOf(false) }

    Box(
        modifier = Modifier
            .sSize(32)
            .cursor(Cursor.Pointer)
            .onClick {
                it.stopPropagation()
                showMenu = !showMenu
            }
            .styleModifier { property("position", "relative") },
        contentAlignment = Alignment.Center,
    ) {
        Icon(
            src = AppIcons.EllipsisVertical,
            modifier = Modifier.sSize(16).styleModifier {
                property("filter", com.arena_web.ui.theme.ThemeVars.ICON_FILTER_V)
            }
        )

        if (showMenu) {
            Box(
                modifier = Modifier
                    .styleModifier {
                        property("position", "absolute")
                        property("top", s(36))
                        property("right", "0")
                        property("z-index", "10")
                        property("min-width", s(140))
                        property("background", "rgba(15, 23, 52, 0.95)")
                        property("border", "1px solid rgba(46, 96, 217, 0.4)")
                        property("border-radius", s(12))
                        property("backdrop-filter", "blur(20px)")
                        property("box-shadow", "0 4px 16px rgba(0, 0, 0, 0.4)")
                        property("overflow", "hidden")
                    }
            ) {
                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .sPadding(12, 16)
                        .cursor(Cursor.Pointer)
                        .onClick {
                            it.stopPropagation()
                            showMenu = false
                            onDelete()
                        }
                        .styleModifier {
                            property("display", "flex")
                            property("align-items", "center")
                            property("gap", s(10))
                        }
                ) {
                    Icon(
                        src = AppIcons.Trash,
                        modifier = Modifier.sSize(18).styleModifier {
                            property("filter", "brightness(0) saturate(100%) invert(27%) sepia(95%) saturate(6000%) hue-rotate(348deg) brightness(95%)")
                        }
                    )
                    SpanText(
                        t.commonDelete,
                        modifier = Modifier.bodyLMedium().color(AppColors.Error)
                    )
                }
            }
        }
    }
}
